module.exports = __webpack_public_path__ + "img/txt.28cbce52.svg";